const keys = {
  49: 1,
  50: 2,
  51: 3,
  52: 4,
  53: 5,
  54: 6,
  55: 7,
  56: 8,
  57: 9,
  48: 0,
  96: 0,
  97: 1,
  98: 2,
  99: 3,
  100: 4,
  101: 5,
  102: 6,
  103: 7,
  104: 8,
  105: 9,
};
export const numKeys = (tvKeyControls) => {
  const channelKeys = Object.assign(
    {
      [tvKeyControls.KEY_0]: 0,
      [tvKeyControls.KEY_1]: 1,
      [tvKeyControls.KEY_2]: 2,
      [tvKeyControls.KEY_3]: 3,
      [tvKeyControls.KEY_4]: 4,
      [tvKeyControls.KEY_5]: 5,
      [tvKeyControls.KEY_6]: 6,
      [tvKeyControls.KEY_7]: 7,
      [tvKeyControls.KEY_8]: 8,
      [tvKeyControls.KEY_9]: 9
    },
    keys);
  return channelKeys
}